import * as types from './types';
import { trim } from 'lodash';

export const showOutput = (output: string) => (dispatch: any) => 
    dispatch({ type: types.OUTPUT_ADD, payload: trim(output).length > 0 ? output : '_' });

export const clear = () => (dispatch: any) => dispatch({ type: types.CLEAR });